var _rect, _path, _rect2, _path2, _rect3, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressStars(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 35,
    viewBox: "0 0 141 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.062,
    width: 32.691,
    height: 32.691,
    rx: 7,
    stroke: "#1F4C47",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.926 18.795h11.23c.398 0 .724-.624.724-1.387 0-.764-.327-1.388-.725-1.388h-11.23c-.398 0-.724.625-.724 1.388 0 .763.326 1.387.725 1.387zM90.367 18.795h11.229c.399 0 .725-.624.725-1.387 0-.764-.326-1.388-.725-1.388H90.367c-.398 0-.724.625-.724 1.388 0 .763.326 1.387.724 1.387zM17.478 8.451a1 1 0 011.816 0l1.94 4.206a1 1 0 00.79.574l4.6.545a1 1 0 01.561 1.727l-3.4 3.145a1 1 0 00-.302.93l.902 4.542a1 1 0 01-1.469 1.067l-4.041-2.262a1 1 0 00-.977 0l-4.042 2.262a1 1 0 01-1.469-1.067l.903-4.543a1 1 0 00-.302-.929l-3.4-3.145a1 1 0 01.56-1.727l4.6-.545a1 1 0 00.79-.574l1.94-4.206z",
    fill: "#1F4C47"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.967,
    y: 1.062,
    width: 32.691,
    height: 32.691,
    rx: 7,
    stroke: "#1F4C47",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.445 8.45a1 1 0 011.816 0l1.94 4.207a1 1 0 00.79.574l4.6.545a1 1 0 01.561 1.727l-3.4 3.145a1 1 0 00-.302.93l.903 4.542a1 1 0 01-1.47 1.067l-4.041-2.262a1 1 0 00-.977 0l-4.042 2.262a1 1 0 01-1.469-1.067l.903-4.543a1 1 0 00-.302-.929l-3.4-3.145a1 1 0 01.56-1.727l4.6-.545a1 1 0 00.79-.574l1.94-4.206z",
    fill: "#1F4C47"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107.309,
    y: 1.062,
    width: 32.691,
    height: 32.691,
    rx: 7,
    stroke: "#1F4C47",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.511 9.032c-.714-1.55-2.917-1.55-3.632 0l-1.94 4.206-4.599.545c-1.695.201-2.376 2.296-1.123 3.455l.679-.735-.679.735 3.401 3.144-.903 4.543c-.332 1.674 1.45 2.968 2.939 2.135l4.041-2.262 4.042 2.262c1.489.834 3.271-.461 2.938-2.135l-.902-4.543 3.4-3.144c1.253-1.16.572-3.254-1.122-3.455l-4.6-.545-1.94-4.206z",
    stroke: "#1F4C47",
    strokeWidth: 2
  })));
}
export default SvgProgressStars;